var map = {
	"./en.json": [
		7473,
		[
			473
		]
	],
	"./kaz.json": [
		4608,
		[
			608
		]
	],
	"./ru.json": [
		4787,
		[
			787
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7995;
module.exports = webpackAsyncContext;